import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import QuotesRequestService from '../../services/quote-request';

import MasterPage from 'components/MasterPage';

import LineChart from 'react-apexcharts';

import ptBr from 'date-fns/locale/pt-BR';

import styles from './style.module.scss';

registerLocale('pt-br', ptBr);

const Charts = () => {
  const defaultFilters = {
    days: 7,
    date_from: null,
    date_to: null,
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);

  let totals = [];

  useEffect(() => {
    if (filters.days || (filters.date_from && filters.date_to)) {
      getChartData();
    }
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (!f.date_from && !f.date_to && !f.days) reset = true;

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const getChartData = () => {
    let params = {
      days: filters.days,
      date_from: filters.date_from
        ? new Date(filters.date_from).toISOString().slice(0, 10)
        : '',
      date_to: filters.date_to
        ? new Date(filters.date_to).toISOString().slice(0, 10)
        : '',
    };

    QuotesRequestService.getQuotesGroupedByDay({ params }).then(({ data }) => {
      let labels = Object.keys(data);

      labels.forEach((label) => {
        totals.push(data[label]);
      });
      setData(totals.reverse());
      setLabels(labels.reverse());
    });
  };

  return (
    <Container fluid className="mt-3">
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Row>
                <Col xs={6} className="align-self-center">
                  <h4 className={styles.headerTitle}>
                    Leads agrupados por dia
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col>
                  <hr className={styles.line} />
                </Col>
              </Row>
              <Row>
                <Col xs={2} className="d-flex justify-content-start">
                  <Form.Group>
                    <Form.Label>Dias:</Form.Label>
                    <Form.Control
                      as="select"
                      value={filters.days}
                      onChange={(e) => {
                        handleFilterChange({
                          days: e.target.value,
                          date_from: null,
                          date_to: null,
                        });
                      }}
                    >
                      <option value={7}>7</option>
                      <option value={15}>15</option>
                      <option value={30}>30</option>
                      <option value={60}>60</option>
                      <option value={90}>90</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col xs={2} className="d-flex justify-content-start">
                  <Form.Group>
                    <Form.Label>Data Inicial:</Form.Label>
                    <DatePicker
                      locale="pt-br"
                      dateFormat="dd/MM/yyyy"
                      selected={!filters.date_from ? '' : filters.date_from}
                      onChange={(date) => {
                        handleFilterChange({
                          days: null,
                          date_from: date,
                        });
                      }}
                      isClearable
                      className="form-control"
                      maxDate={new Date()}
                    />
                  </Form.Group>
                </Col>
                <Col xs={2} className="d-flex justify-content-start">
                  <Form.Group>
                    <Form.Label>Data Final:</Form.Label>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={!filters.date_to ? '' : filters.date_to}
                      onChange={(date) => {
                        handleFilterChange({
                          days: null,
                          date_to: date,
                        });
                      }}
                      isClearable
                      className="form-control"
                      minDate={filters.date_from}
                      maxDate={new Date()}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <hr className={styles.line} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LineChart
                    options={{
                      chart: {
                        id: 'leads-chart',
                      },
                      xaxis: {
                        categories: labels,
                      },
                      yaxis: {
                        labels: {
                          formatter: function (d) {
                            return parseInt(d);
                          },
                        },
                      },
                      stroke: {
                        curve: 'smooth',
                        colors: ['#D9232F'],
                      },
                      fill: {
                        type: 'gradient',
                        colors: ['#D9232F'],
                      },
                    }}
                    series={[
                      {
                        name: 'Leads',
                        data: data,
                      },
                    ]}
                    type="area"
                    height={500}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MasterPage(Charts);
